"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatForDayjs = void 0;
const lang_1 = require("../lang");
const getFormatForDayjs = () => {
    switch ((0, lang_1.getCurrentLng)()) {
        case 'en':
            return 'MMMM DD [at] HH:mm';
        default:
            return 'DD MMMM, HH:mm';
    }
};
exports.getFormatForDayjs = getFormatForDayjs;
//# sourceMappingURL=getFormatForDayjs.js.map